// The building grid on one sheet page (back: GET /glance/sheet-grid, utils/glance/locate.sheetGrid):
// { lines: [{ label, axis: 'x'|'y', a: [px, py], b: [px, py] }] in page percent, reason }.
//
// ANY FAILURE RESOLVES TO { lines: [], reason: 'unavailable' } RATHER THAN THROWING: the grid is a reading aid
// on a sheet, and the sheet must still open without it.
import { url, tokenRef } from "api";

const auth = () => {
  const t = localStorage.getItem(tokenRef);
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const getSheetGrid = async (projectId, docId, page = 1) => {
  try {
    const res = await fetch(`${url}/projects/${projectId}/glance/sheet-grid?docId=${encodeURIComponent(docId)}&page=${Number(page) || 1}`, { headers: auth() });
    if (!res.ok) return { lines: [], reason: "unavailable" };
    const body = await res.json();
    return { lines: Array.isArray(body.lines) ? body.lines : [], reason: body.reason || null };
  } catch (e) {
    return { lines: [], reason: "unavailable" };
  }
};

// What to say when there is nothing to draw - in the person's words, never silent.
export const SHEET_GRID_WHY = {
  "no-grid": "This project has no building grid yet",
  "not-registered": "This page is not placed on the building grid yet",
  "off-page": "The building grid falls outside this page",
  unavailable: "The building grid could not be loaded",
};
